import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import { getToolkitIcon } from "@arcadeai/design-system/metadata/toolkit-icons";
import { FilterIcon, Search, X } from "lucide-react";
import { useToolkitPicker } from "../hooks/use-toolkit-picker";

export function FilterBadges() {
  const {
    state: { toolkitFilter, searchQuery, filteredToolkits },
    setActiveTab,
    clearFilter,
    clearSearchQuery,
  } = useToolkitPicker();

  if (!(toolkitFilter || searchQuery)) {
    return null;
  }

  return (
    <div className="mb-2 flex flex-wrap items-center gap-2">
      {!!toolkitFilter && (
        <Badge
          className="h-8 border border-purple-200 bg-purple-50 pr-1.5 pl-2 text-purple-800 shadow-sm ring-1 ring-purple-200/50 dark:border-purple-800/60 dark:bg-purple-950/40 dark:text-purple-200 dark:ring-purple-800/30"
          variant="secondary"
        >
          <span className="mr-1.5 inline-flex items-center gap-1 rounded-full bg-purple-100 px-1.5 py-0.5 text-[10px] text-purple-700 dark:bg-purple-800/60 dark:text-purple-200">
            <FilterIcon className="h-3 w-3" />
            Filter
          </span>
          <button
            className="inline-flex h-full items-center gap-1.5"
            data-testid="filter-badge"
            onClick={() => setActiveTab("toolkits")}
            type="button"
          >
            {(() => {
              const filteredToolkit = Array.from(filteredToolkits).find(
                (tk) => tk.name === toolkitFilter
              );
              const Icon = getToolkitIcon(filteredToolkit?.metadata?.id);
              return <Icon className="h-3.5 w-3.5" />;
            })()}
            <span className="font-medium text-xs">{toolkitFilter}</span>
          </button>
          <button
            aria-label="Clear toolkit filter"
            className="ml-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-purple-100 text-red-600 hover:bg-red-100 hover:text-red-700 focus-visible:ring-[3px] focus-visible:ring-red-200 dark:bg-purple-800/60 dark:text-red-400 dark:hover:bg-red-950/40 dark:hover:text-red-300"
            data-testid="clear-filter"
            onClick={clearFilter}
            type="button"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </Badge>
      )}

      {!!searchQuery && (
        <Badge
          className="h-8 border border-teal-200 bg-teal-50 pr-1.5 pl-2 text-teal-800 shadow-sm ring-1 ring-teal-200/50 dark:border-teal-800/60 dark:bg-teal-950/40 dark:text-teal-200 dark:ring-teal-800/30"
          variant="secondary"
        >
          <span className="mr-1.5 inline-flex items-center gap-1 rounded-full bg-teal-100 px-1.5 py-0.5 text-[10px] text-teal-700 dark:bg-teal-800/60 dark:text-teal-200">
            <Search className="h-3 w-3" />
            Search
          </span>
          <span className="font-medium text-xs">"{searchQuery}"</span>
          <button
            aria-label="Clear search query"
            className="ml-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-teal-100 text-red-600 hover:bg-red-100 hover:text-red-700 focus-visible:ring-[3px] focus-visible:ring-red-200 dark:bg-teal-800/60 dark:text-red-400 dark:hover:bg-red-950/40 dark:hover:text-red-300"
            data-testid="clear-search"
            onClick={clearSearchQuery}
            type="button"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </Badge>
      )}
    </div>
  );
}
